import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { checkValidity } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Components
import * as icons from '../Icons/Icons';

const Roles = observer(class Roles extends React.Component {
  constructor() {
    super();
    this.addRole = this.addRole.bind(this);
    this.removeRole = this.removeRole.bind(this);
    this.handleRoleInput = this.handleRoleInput.bind(this);
    this.handleRoleSubmit = this.handleRoleSubmit.bind(this);
  }

  componentWillMount() {
    this.state = {
      integrationSid: this.props.integrationSid,
      roles: []
    }

    this.props.store.SettingsStore.getCustomRoles(this.props.integrationSid, this);
    this.props.store.SettingsStore.getIntegration(this.props.integrationSid);
  }

  componentWillUnmount() {
    this.props.store.SettingsStore.customRoles = [];
  }

  addRole() {
    let roles = this.state.roles;

    const newRole = {
      incomingRole: null,
      systemRole: 'Learner',
      caseSensitive: false
    }

    roles.push(newRole);

    console.log(roles);

    this.setState({
      roles
    });
  }

  removeRole(index) {
    let roles = [...this.state.roles];

    roles.splice(index, 1);

    this.setState({
      roles
    });
  }

  handleRoleInput(e, i, field) {
    let roles = [...this.state.roles];
    let editedRole = roles[i];

    if(field === 'incomingRole') {
      editedRole.incomingRole = e.target.value;
    } else {
      editedRole.systemRole = e.target.value;
    }

    this.setState({
      roles
    });
  }

  handleRoleSubmit() {
    this.props.store.SettingsStore.updateCustomRoles(
      this.state.integrationSid, this.state.roles, this.props.complete
    );
  }

  render() {
    const { translation } = this.props;
    const { SessionStore } = this.props.store;
    const { integration } = this.props.store.SettingsStore;

    return (
      <div className="drawer__content">
        <header className="drawer__header">
          <div className="wrap">
            <h1 className="drawer__title">{translation.heading} {integration.name}</h1>
          </div>
        </header>

        <div className="wrap block-form">
          {/* <p className="note">{translation.note}</p> */}

          {(!SessionStore.loading || this.state.roles.length > 0) &&
            <form className="panel" onSubmit={(e) => checkValidity(e, this.handleRoleSubmit)} noValidate>
              <div className="panel__body">
                <fieldset className="form-section">
                  {/* Button to add first custom role */}
                  {this.state.roles.length === 0 &&
                    <button
                      className="btn btn--success"
                      onClick={this.addRole}
                      type="button"
                    >
                      <icons.iconPlus />
                      {translation.add_first}
                    </button>
                  }


                  {this.state.roles.length > 0 &&
                    <label className="lbl-block" htmlFor="custom-role-0">
                      {translation.roles}
                    </label>
                  }

                  {this.state.roles.length > 0 &&
                    <ul className="fields">
                      {this.state.roles.map(
                        (key, i) =>
                        <li className="form-inline" key={i}>
                          <label className="meta" htmlFor={`custom-role-${i}`}>
                            {translation.input}
                          </label>

                          <input
                            id={`custom-role-${i}`}
                            type="text"
                            placeholder={translation.input}
                            value={key.incomingRole || ''}
                            onChange={(e) => this.handleRoleInput(e, i, 'incomingRole')}
                            required
                            aria-required="true"
                          />

                          <span className="preposition">=</span>

                          <label className="select" htmlFor={`sp-role-${i}`}>
                            <span className="meta">{translation.select}</span>

                            <select
                              id={`sp-role-${i}`}
                              value={key.systemRole || ''}
                              onChange={(e) => this.handleRoleInput(e, i, 'systemRole')}
                              required
                              aria-required="true"
                            >
                              <option value="">{translation.select}…</option>
                              {Object
                                .keys(translation.options)
                                .map(
                                  (option) =>
                                  <option value={option} key={option}>
                                    {translation.options[option]}
                                  </option>
                                )
                              }
                            </select>
                          </label>

                          <div className="btns">
                            <button
                              className="btn--add"
                              type="button"
                              onClick={this.addRole}
                            >
                              <icons.iconPlus />
                              <span className="meta">{translation.add}</span>
                            </button>

                            <button
                              className="btn--remove"
                              type="button"
                              onClick={() => this.removeRole(i)}
                            >
                              <icons.iconMinus />
                              <span className="meta">{translation.remove}</span>
                            </button>
                          </div>
                        </li>
                      )}
                    </ul>
                  }
                </fieldset>

                <div className="panel__actions actions">
                  <button
                    className="actions__btn actions__btn--primary"
                    type="submit"
                  >
                    {translation.save}
                  </button>
                </div>
              </div>
            </form>
          }
        </div>
      </div>
    )
  }
})

export default translate('Roles')(Roles);


// WEBPACK FOOTER //
// ./src/app/components/Integrations/Roles.js